module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc_title"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmbm"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_fwd"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmbm"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_itr"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tspl"
  }, [_c('strong', [_vm._v("Jams & Preserves")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tspl"
  }, [_c('strong', [_vm._v("Fruit Butters & Jellies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tspl"
  }, [_c('strong', [_vm._v("Compotes, Chutneys & Marmalades")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tspl"
  }, [_c('strong', [_vm._v("Pickles & Relishes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tspl"
  }, [_c('strong', [_vm._v("Pickled Fruits & Vegetables")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmbm"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_crd",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("PHOTOGRAPHY CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmbm"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781618372475_bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("METRIC CONVERSION CHARTS")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5f7b70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781618372475_toc.vue
// module id = 66
// module chunks = 0